<template>
  <section class="hero">
    <div class="hero_images">
      <div class="hero_img" data-responsive-background-image>
        <img
            :srcset="imageSet"
            :src="$props.config.image_url"
        >
      </div>
      <div class="container hero_container ">
        <div class="row">
          <div class="col-1 hidden-sm"></div>
          <div class="col-10">
            <SearchFormLitepicker
                :title="$props.title"
                :loc="$props.loc"
                :wknd="$props.wknd"
                :params="$props.params"
                :region="$props.region"
                :page="'cms-new'"
                :cal="'static'"
            />
          </div>
        </div>
      </div>
      <div class="search_pnts">
        <h3 class="search_txt">
          <svg class="search_t">
            <use xlink:href="#ico-tick"></use>
          </svg>
          Live availability
        </h3>
        <h3 class="search_txt">
          <svg class="search_t">
            <use xlink:href="#ico-tick"></use>
          </svg>
          Live prices
        </h3>
        <h3 class="search_txt">
          <svg class="search_t">
            <use xlink:href="#ico-tick"></use>
          </svg>
          Book instantly
        </h3>
      </div>
    </div>
    <div class="following-form" :class="{'show': show}" >
      <div class="container">
        <div class="row">
          <div class="col-12">
            <SearchFormLitepicker
                :loc="$props.loc"
                :wknd="$props.wknd"
                :params="$props.params"
                :region="$props.region"
                :page="'cms'"
                :cal="'fixed'"
                v-if="!device"
            />
            <button @click="scrollTop" class="btn mobile-button" v-if="device">Start searching</button>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import ResponsiveBackgroundImage from 'lib/responsiveImage.js'
import SearchFormLitepicker from "../shared/searchFormLitepicker";

export default {

  data: function () {
    return {
      heroImage: this.$props.config.image_url,
      absolute: false,
      imageSet: '',
      show: false,
      device: window.innerWidth < 1024
    }
  },
  props: {
    title: Array,
    config: Object,
    page: Object,
    hero: String,
    mobileImage: String,
    loc: String,
    wknd: String,
    params: Array,
    region: String
  },
  components: {
    SearchFormLitepicker,
  },
  methods: {
    scrollTop() {
      window.scrollTo({
        top:0,
        behavior: 'smooth'
      });
      setTimeout(() => {
        document.querySelector('#region').focus();
      }, 1500);
    }
  },
  mounted: function () {
    let app = this;
    let elements = document.querySelectorAll('[data-responsive-background-image]');
    for (let i=0; i<elements.length; i++) {
      new ResponsiveBackgroundImage(elements[i]);
    }

    document.addEventListener('scroll', function(e) {
      app.show = window.pageYOffset >= 800
    });

    window.addEventListener('resize', function(e) {
      app.device = window.innerWidth < 1024;
    });

    if(this.$props.config.mobile_image_url && this.$props.config.image_url) {
      this.imageSet = this.$props.config.mobile_image_url + ' 800w, ' + this.$props.config.image_url + ' 1600w'
    }
  }
}


</script>

<style scoped lang="scss">
@import 'app/assets/stylesheets/_vars.scss';

.hero {
  min-height: 37rem;
  position: relative;
  background: #424F98;
  height: calc(100vh - 2.75rem);

  @media #{$desktop} {
    height: 100%;
  }
}

.row {
  height: 100%;
}

.col-10 {
  margin: 0;
  width: 100%;
  height: 100%;
  position: relative;

  @media #{$desktop} {
    margin: 0 2%;
    width: 79.3333333333%;
  }
}

.hero_container {
  padding-bottom: 46px;
  box-sizing: border-box;

  @media #{$desktop} {
    padding-bottom: 0;
  }
}

.hero_images {
  height: 100%;
  width: 100%;
  position: absolute;
  top: 0;
  left: 0;

  &:after {
    display: none;
  }
}

.hero_img {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  filter: saturate(120%);
  background-repeat: no-repeat;
  height: 100%;
  background-position: 50% 50%;
  background-size: cover;
  z-index: 0;
  will-change: opacity;
}

.search_pnts {
  padding: 1.25rem 0;
  display: -webkit-box;
  display: -moz-box;
  display: -ms-flexbox;
  display: -webkit-flex;
  display: flex;
  width: 100%;
  flex-direction: row;
  flex: 1 1 auto;
  position: absolute;
  justify-content: space-around;
  bottom: -1px;
  background: white;
  z-index: 1;

  h3 {
    text-align: center;
    font-weight: 400;
    font-size: .875rem;
  }

  svg {
    width: .875rem;
    top: .125rem;
    height: .875rem;
    position: relative;
  }
}

[data-responsive-background-image] {
  background-size: cover;
  background-position: center center;
  background-repeat: no-repeat;
  display: inline-block;
}

[data-responsive-background-image] img {
  display: none;
}

.following-form {
  width: 100%;
  background: $col_xlgrey;
  position: fixed;
  z-index: 9;
  top: 0;
  opacity: 0;
  transition: opacity .5s ease;

  &.show {
    opacity: 1;
  }
}

.show-cal .following-form {
  display: none;
}

.mobile-button {
  margin: 1.25rem;
  padding: 0 2.5rem;
  font-size: .875rem;
  border-radius: 0.2rem;
  box-shadow: 0 .063rem .125rem rgba(0, 0, 0, 0.3);
  height: 3.125rem;
  background: $col_primary;
  color: $col_white;
  font-weight: 700;
  width: calc(100% - 2.5rem);
  box-sizing: border-box;
}

@media #{$desktop} {
  .search_pnts {
    display: none;
  }

  .hero {
    height: 100%;
    min-height: 31rem;
  }

  .following-form {
    height: 4.625rem;
  }
}

</style>